import React, { useCallback, useRef, useState } from 'react';
import OptionConfigurationEntryFlow from './OptionConfigurationEntryFlow';
import { optionsToEntryView, entryViewToOptions, prepareOptionEntries } from './optionConfigurationView';

 
const OptionConfigurationEditor = ({ option, onSave, onClose }) => {
  const identities = useRef(new WeakMap());
  const normalizeKeywords = useCallback(entries => prepareOptionEntries(entries, identities.current), []);
  const [initialEntries] = useState(() => optionsToEntryView(option));
  const saveEntries = (entries) => {
    const result = entryViewToOptions(entries, identities.current);
    const patch = result.label != null && result.label !== option.label ? {
      label: result.label,
      value: result.label.trim().replace(/\s+/g, ''),
    } : {};
    if (result.isMultiple != null && result.isMultiple !== Boolean(option.isMultiple)) {
      patch.isMultiple = result.isMultiple;
    }
    onSave(result.options, patch);
  };

  return (
    <OptionConfigurationEntryFlow
      LinkFor="HPI"
      normalizeKeywords={normalizeKeywords}
      linkData={initialEntries}
      setLinkData={saveEntries}
      closeEditModel={onClose}
      setLinkModel={(visible) => { if (!visible) onClose(); }}
      addFormMade={() => {}}
    />
  );
};

export default OptionConfigurationEditor;
